var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7164 0.941989C15.5325 0.941989 16.2231 1.63256 16.2231 2.44868V9.98215C16.2231 12.7758 13.9631 15.0045 11.2008 15.0045H10.9497C10.5102 15.0045 10.1963 14.6906 10.1963 14.2511V12.7444C10.1963 12.3364 10.5102 11.9911 10.9497 11.9911H11.2008C12.2994 11.9911 13.2097 11.1122 13.2097 9.98215V7.97323H10.6986C9.85106 7.97323 9.19188 7.31405 9.19188 6.46653V2.44868C9.19188 1.63256 9.85106 0.941989 10.6986 0.941989H14.7164ZM5.67626 0.941989C6.49239 0.941989 7.18295 1.63256 7.18295 2.44868V9.98215C7.18295 12.7758 4.92291 15.0045 2.16064 15.0045H1.90953C1.47007 15.0045 1.15618 14.6906 1.15618 14.2511V12.7444C1.15618 12.3364 1.47007 11.9911 1.90953 11.9911H2.16064C3.25927 11.9911 4.16957 11.1122 4.16957 9.98215V7.97323H1.65841C0.810897 7.97323 0.151718 7.31405 0.151718 6.46653V2.44868C0.151718 1.63256 0.810897 0.941989 1.65841 0.941989H5.67626Z",
    fill: "#12B897"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteRight);
export default __webpack_public_path__ + "static/media/quote-right.6c5457391a9da0ca33b362bd3da61585.svg";
export { ForwardRef as ReactComponent };